import React from 'react'
import PropTypes from 'prop-types'
import { compose, pure } from 'recompose'

import EditorDropDown from '../../molecules/EditorDropDown/EditorDropDown'
import './EditRanking.css'

const EditRanking = ({ onChangeRankingConfig, contents, selectedValue }) => (
  <div styleName="container">
    <ul styleName="tabs_labels">
      <li styleName="tabs_li active">
        <div styleName="tab">
          <p styleName="tabText">結果発表</p>
        </div>
      </li>
    </ul>
    <div styleName="section">
      <p styleName="title">表彰する人数</p>
      <EditorDropDown
        idx={0}
        handleChange={onChangeRankingConfig}
        optionsContents={contents}
        selectedValue={selectedValue}
      />
    </div>
  </div>
)

EditRanking.propTypes = {
  selectedValue: PropTypes.number,
  contents: PropTypes.array,
  onChangeRankingConfig: PropTypes.func
}

export default compose(pure)(EditRanking)
